












import Vue from 'vue'

import Application from '@/layout/common/Head.vue'
import ApplicationFooter from '@/layout/common/Footer.vue'

export default Vue.extend({
  name: 'Default',
  components: {
    Application,
    ApplicationFooter
  }
})
